/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_NavInputs */

const en_tut_nav = /** @type {(inputs: Tut_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial`)
};

const id_tut_nav = /** @type {(inputs: Tut_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial`)
};

/**
* | output |
* | --- |
* | "Tutorial" |
*
* @param {Tut_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_nav = /** @type {((inputs?: Tut_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_nav(inputs)
	return en_tut_nav(inputs)
});